// Anonymous device-scoped UUID stored in localStorage.
// IMPORTANT: When the user is signed in, RLS requires inserts to use
// auth.uid() — the local anon id will be rejected. Use `getEffectiveUserId()`
// at insert sites to pick the right id automatically.
import { supabase } from "@/integrations/supabase/client";

const KEY = "pleasant.anon.uid";

export function getAnonUserId(): string {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}

/**
 * Returns the signed-in user's id when a session exists, otherwise the
 * device-scoped anonymous id. This matches the RLS rule
 * `auth.uid() IS NULL OR auth.uid() = user_id` on community tables.
 */
export async function getEffectiveUserId(): Promise<string> {
  try {
    const { data } = await supabase.auth.getSession();
    const uid = data.session?.user?.id;
    if (uid) return uid;
  } catch {
    // fall through to anon
  }
  return getAnonUserId();
}
